import { PillColor, SharedModule } from '@aiwyn/shared';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EsignSigningContextSigner } from '../../../../models';

/**
 * The "Review & Sign" roster — signature count plus one row per signer with their status.
 *
 * Rendered on the hub (before signing) and on every completion variant, which is why it lives here
 * rather than inline in the container template: the two would otherwise drift.
 */
@Component({
  selector: 'app-esign-signer-roster',
  imports: [SharedModule],
  templateUrl: './esign-signer-roster.component.html',
  styleUrl: './esign-signer-roster.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsignSignerRosterComponent {
  readonly signers = input.required<EsignSigningContextSigner[]>();

  /**
   * A bundle always has at least one signer, so an empty roster means the field was absent from the
   * response — an artengine older than the one that added `signers`. Hiding the block is the honest
   * rendering: "Signatures required 0" would assert something false.
   */
  protected readonly hasSigners = computed(() => this.signers().length > 0);

  protected isSigned(signer: EsignSigningContextSigner): boolean {
    return signer.status === 'SIGNED';
  }

  protected statusLabel(signer: EsignSigningContextSigner): string {
    return this.isSigned(signer) ? 'Signed' : 'Pending';
  }

  protected statusColor(signer: EsignSigningContextSigner): PillColor {
    return this.isSigned(signer) ? 'green' : 'orange';
  }
}
